export default [
  {
    id: 1,
    name: 'Feuer / Großbrand',
  },
  {
    id: 2,
    name: 'Chemieunfall',
  },
  {
    id: 3,
    name: 'Schulausfall',
  },
  {
    id: 4,
    name: '(Tier-) Seuchenfall',
  },
  {
    id: 5,
    name: 'Erdfall / Erdrutsch',
  },
  {
    id: 6,
    name: 'Verkehrsinformationen',
  },
  {
    id: 7,
    name: 'Großschadenslage',
  },
  {
    id: 8,
    name: 'Warnung',
  },
  {
    id: 9,
    name: 'Hochwasser',
  },
  {
    id: 10,
    name: 'Unwetter / DWD',
  },
  {
    id: 11,
    name: 'Bombenfund',
  },
  {
    id: 12,
    name: 'Information',
  },
  {
    id: 13,
    name: 'Lawine',
  },
  {
    id: 14,
    name: 'Fahndungsaufruf',
  },
  {
    id: 15,
    name: 'Polizeimeldung',
  },
  {
    id: 17,
    name: 'Energieversorgung',
  },
];



// WEBPACK FOOTER //
// ./src/js/constants/categories.js